<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <div v-if="!organizaciones.length" class="alert alert-custom alert-light-warning py-2 mb-0">
      <i class="fa fa-info-circle mr-1"></i>
      No hay organizaciones registradas para este ámbito.
    </div>
    <div v-else class="d-flex flex-wrap sheet-opciones-grupo" role="group">
      <button v-for="org in organizaciones" :key="org.parametroId" type="button" class="btn btn-sm btn-sheet-opcion mb-1"
              :class="[estaSeleccionada(org.parametroId) ? 'btn-primary' : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="alternar(org.parametroId)">
        <img v-if="org.imagen" :src="apiResource(org.imagen)" class="mr-1"
             style="height: 20px; width: auto; vertical-align: middle;" @error="ocultar" />
        {{ org.descripcion }}
      </button>
    </div>
  </q-fila>
</template>

<script>
/**
 * Selección múltiple de organizaciones políticas / movimientos regionales.
 *
 * La lista llega SIEMPRE del API (tabla Parametro, filtrada por ámbito y región):
 * aquí no hay ninguna organización escrita en el código. El texto visible es
 * Parametro.Descripcion. Se persiste una lista de ParametroId.
 *
 * El separador es "|" y no coma, porque el nombre de las organizaciones y
 * movimientos regionales contiene comas y la ficha guarda además un texto con
 * esos nombres que debe poder volverse a partir.
 */
import QFila from "./QFila";

export default {
  name: "QOrganizaciones",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    organizaciones: { type: Array, default: () => [] },
    separador: { type: String, default: "|" },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    seleccionadas() {
      return String(this.value || "")
        .split(this.separador)
        .map((x) => x.trim())
        .filter((x) => x.length > 0);
    },
    respondida() {
      return this.seleccionadas.length > 0;
    },
  },
  methods: {
    estaSeleccionada(id) {
      return this.seleccionadas.indexOf(String(id)) >= 0;
    },
    alternar(id) {
      if (this.soloLectura) return;
      const actuales = this.seleccionadas.slice();
      const i = actuales.indexOf(String(id));
      if (i >= 0) actuales.splice(i, 1);
      else actuales.push(String(id));
      this.$emit("input", actuales.length ? actuales.join(this.separador) : null);
    },
    ocultar(e) {
      e.target.style.display = "none";
    },
  },
};
</script>
